import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Save, ArrowLeft } from 'lucide-react';
import { useAnnouncement, useUpdateAnnouncement } from '../../lib/queries';

export default function EditAnnouncement() {
  const navigate = useNavigate();
  const { data, isLoading } = useAnnouncement();
  const update = useUpdateAnnouncement();
  const [html, setHtml] = useState('');

  useEffect(() => {
    if (data) setHtml(data.announcementHtml);
  }, [data]);

  if (isLoading) return <p className="text-ink-muted">Laddar…</p>;

  function handleSave() {
    void (async () => {
      try {
        await update.mutateAsync(html);
        await navigate('/admin');
      } catch {
        // ignored
      }
    })();
  }

  return (
    <div className="max-w-3xl mx-auto">
      <button
        type="button"
        onClick={() => navigate('/admin')}
        className="flex items-center gap-2 text-ink-muted mb-4 hover:text-ink"
      >
        <ArrowLeft size={16} /> Tillbaka
      </button>

      <h1 className="text-3xl font-serif text-primary mb-6">Redigera meddelande</h1>

      <div className="bg-white rounded-2xl p-4 shadow-sm">
        <ReactQuill theme="snow" value={html} onChange={setHtml} />
      </div>

      <button
        type="button"
        onClick={handleSave}
        disabled={update.isPending}
        className="mt-4 bg-primary hover:bg-primary-hover text-white px-6 py-3 rounded-lg flex items-center gap-2 disabled:opacity-50"
      >
        <Save size={18} /> Spara
      </button>
    </div>
  );
}
